export const EXPERIMENT_ASSET_LABELS = {
  feature_set: 'Feature Set',
  dataset: 'Dataset',
  parameter_set: 'Parameter Set',
  artifact: 'Artifact',
  run: 'Run',
  experiment: 'Experiment',
  project: 'Project',
} as const;

export type ExperimentAssetType = keyof typeof EXPERIMENT_ASSET_LABELS;

export const EXPERIMENT_ASSET_TYPES_FULL = ['experiment', 'run', 'feature_set', 'dataset', 'artifact'] as const;

export const EXPERIMENT_ASSET_TYPES_WITHOUT_EXPERIMENT = ['run', 'feature_set', 'dataset', 'artifact'] as const;

export const TIER_TO_DATABASE_MAP = {
  bronze: 'bronze-iceberg',
  silver: 'silver-iceberg',
  gold: 'gold-iceberg',
} as const;

export type TierType = keyof typeof TIER_TO_DATABASE_MAP;

export const buildStandaloneAssetFqn = (tier: string, namespace: string, table: string): string => {
  const normalizedTier = tier.toLowerCase() as TierType;
  const database = TIER_TO_DATABASE_MAP[normalizedTier];

  if (!database) {
    throw new Error(`Invalid tier: ${tier}. Expected one of: bronze, silver, gold`);
  }

  return `${database}.${tier}.${namespace}.${table}`;
};
